var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BaseApi } from '../baseApi';
export default class BillingPlansApi extends BaseApi {
    constructor() {
        super(...arguments);
        this.apiBasePath = 'billing-plans';
    }
    getPlans() {
        return __awaiter(this, arguments, void 0, function* (params = {}) {
            return yield this.apiCall({
                method: 'GET',
                route: `${this.apiBasePath}`,
                params: params,
            });
        });
    }
    createPlan(data) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiCall({
                method: 'POST',
                route: `${this.apiBasePath}`,
                data,
            });
        });
    }
    updatePlan(id, data) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiCall({
                method: 'PUT',
                route: `${this.apiBasePath}`,
                params: { id },
                data,
            });
        });
    }
    deletePlan(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiCall({
                method: 'DELETE',
                route: `${this.apiBasePath}`,
                params: { id: id },
            });
        });
    }
}
//# sourceMappingURL=index.js.map